import { createFetchTypes } from '../../utils/createFetchTypes';

export const SET_WORKSPACE = 'SET_WORKSPACE';
export const IS_CHANGING_CLINIC = 'IS_CHANGING_CLINIC';
export const USER_INFO = 'USER_INFO';
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE';
export const RESET_STORE = 'RESET_STORE';
export const CREATE_USER = 'CREATE_USER';
export const EDIT_USER_ACCESS = 'EDIT_USER_ACCESS';
export const RESET_USER_FOUND = 'RESET_USER_FOUND';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
// ************ createFetchTypes

export const GET_POLYCLINICS = createFetchTypes('GET_POLYCLINICS');
export const GET_USERS = createFetchTypes('GET_USERS');
export const USER_FOUND = createFetchTypes('USER_FOUND');
export const GET_USER = createFetchTypes('GET_USER');
